import { Campaign } from '@/types/campaign.types';
import { EmailTypeDisplayNames, EmailTypeEnum } from '@/types/email.types';

const STATUS_COLORS = {
  sent: '#22C55E',
  scheduled: '#3B82F6',
  draft: '#64748B',
} as const;

export const getCampaignStatusColor = (status: Campaign['state']) => {
  switch (status) {
    case 'published':
    case 'generated':
    case 'sent':
      return { color: STATUS_COLORS.sent, mix: `${STATUS_COLORS.sent}1A`, borderColor: STATUS_COLORS.sent };
    case 'scheduled':
      return {
        color: STATUS_COLORS.scheduled,
        mix: `${STATUS_COLORS.scheduled}1A`,
        borderColor: STATUS_COLORS.scheduled,
      };
    case 'draft':
    default:
      return { color: STATUS_COLORS.draft, mix: `${STATUS_COLORS.draft}1A`, borderColor: STATUS_COLORS.draft };
  }
};

export const getCampaignStatusLabel = (status: Campaign['state']) => {
  switch (status) {
    case 'published':
    case 'generated':
      return 'Published';
    case 'sent':
      return 'Sent';
    case 'scheduled':
      return 'Scheduled';
    case 'draft':
    default:
      return 'Draft';
  }
};

export const campaignSelectTypes = (regDisabled = false) => [
  {
    label: EmailTypeDisplayNames[EmailTypeEnum.event_registration_email],
    value: EmailTypeEnum.event_registration_email,
    isDisabled: regDisabled,
  },
  { label: EmailTypeDisplayNames[EmailTypeEnum.event_invite], value: EmailTypeEnum.event_invite },
  { label: EmailTypeDisplayNames[EmailTypeEnum.session_ended], value: EmailTypeEnum.session_ended },
  { label: EmailTypeDisplayNames[EmailTypeEnum.session_reminder], value: EmailTypeEnum.session_reminder },
  { label: EmailTypeDisplayNames[EmailTypeEnum.session_live], value: EmailTypeEnum.session_live },
];
